// ─── 8-K items · their Hebrew names (sprint 21) ─────────────────────────────
//
// The client's copy of ITEMS in netlify/functions/lib/edgar8k.js, which
// decides the event type when a report is stored. secItems.sync.test.js
// fails when the two differ.

export const SEC_ITEMS = {
  "1.01": { he: "הסכם מהותי", type: "deal" },
  "1.02": { he: "סיום הסכם מהותי", type: "deal" },
  "1.03": { he: "פשיטת רגל או כינוס", type: "legal" },
  "1.04": { he: "בטיחות במכרות", type: "legal" },
  "1.05": { he: "אירוע אבטחת סייבר מהותי", type: "legal" },
  "2.01": { he: "השלמת רכישה או מכירה של נכסים", type: "mna" },
  "2.02": { he: "תוצאות כספיות", type: "earnings" },
  "2.03": { he: "התחייבות פיננסית חדשה", type: "deal" },
  "2.04": { he: "אירוע שמאיץ התחייבות פיננסית", type: "legal" },
  "2.05": { he: "עלויות יציאה או ארגון מחדש", type: "other" },
  "2.06": { he: "ירידת ערך מהותית", type: "earnings" },
  "3.01": { he: "הודעה על מחיקה מהמסחר", type: "legal" },
  "3.02": { he: "מכירת מניות שלא נרשמה", type: "other" },
  "3.03": { he: "שינוי בזכויות בעלי המניות", type: "legal" },
  "4.01": { he: "החלפת רואה החשבון המבקר", type: "management" },
  "4.02": { he: "דוחות קודמים שאין להסתמך עליהם", type: "legal" },
  "5.01": { he: "שינוי בשליטה", type: "mna" },
  "5.02": { he: "שינוי בהנהלה או בדירקטוריון", type: "management" },
  "5.03": { he: "תיקון תקנון או שינוי שנת כספים", type: "other", technical: true },
  "5.04": { he: "השעיה זמנית של תוכנית חיסכון", type: "other", technical: true },
  "5.05": { he: "תיקון קוד האתיקה", type: "other", technical: true },
  "5.06": { he: "שינוי במעמד חברת מעטפת", type: "other" },
  "5.07": { he: "הצבעת בעלי המניות", type: "other" },
  "5.08": { he: "מועמדים לדירקטוריון", type: "management" },
  "7.01": { he: "גילוי לפי Regulation FD", type: "other" },
  "8.01": { he: "אירועים אחרים", type: "other" },
  "9.01": { he: "דוחות כספיים ונספחים", type: "other", technical: true },
};

// "הסכם מהותי" for an 8-K's main item · "דיווח שוטף" for a 6-K, which has none.
export function itemLabel(form, item) {
  if (/^6-K/i.test(form || "")) return "דיווח שוטף";
  return SEC_ITEMS[item]?.he || "דיווח שוטף";
}
